// global types
export const ADD_TO_FRONTEND = 'ADD_TO_BACKEND'

// login section
export const EMAIL = 'EMAIL'
export const PASSWORD = 'PASSWORD'
export const USERNAME = 'USERNAME'
export const LAST_NAME = 'LAST_NAME'
export const FIRST_NAME = 'FIRST_NAME'

// user section
export const LOGOUT = 'LOGOUT'
export const USER_ID = 'USER_ID'
export const OTHER_USER = 'OTHER_USER'
export const USER_F_NAME = 'USER_F_NAME'
export const USER_L_NAME = 'USER_L_NAME'
export const CURR_USERNAME = 'CURR_USERNAME'
export const ADD_USER_POST = 'ADD_USER_POST'
export const AUTHENTICATED = 'AUTHENTICATED'
export const GET_USER_POSTS = 'GET_USER_POSTS'
export const INCOMING_NEW_POST = 'INCOMING_NEW_POST'

//post section
export const GET_POST = 'GET_POST'
export const GET_ONE_POST = 'GET_ONE_POST'

//post form section
export const TITLE = 'TITLE'
export const CREATE_POST = 'CREATE_POST'
export const DESCRIPTION = 'DESCRIPTION'
export const UPDATE_LIKE = 'UPDATE_LIKE'
export const DESTROY_POST = 'DESTROY_POST'
export const UPLOAD_IMAGES = 'UPLOAD_IMAGES'
export const SET_USER_ID_FORM = 'SET_USER_ID_FORM'

//image form section
export const POST_ID = 'POST_ID'
export const RESET_IMAGE = 'RESET_IMAGE'
export const FIRST_SUBMIT = 'FIRST_SUBMIT'
export const USER_ID_IMAGE = 'USER_ID_IMAGE'
export const CLEAR_IMAGE_FORM = 'CLEAR_IMAGE_FORM'

//auth form section
export const HANDLE_LOGIN = 'HANDLE_LOGIN'
export const CREATE_A_USER = 'CREATE_A_USER'
